const constants = {
	SERVICIOS: "servicios-tecnicos",
}

export const PAGES = {
	INICIO: "inicio",
	NOSOTROS: "quienes-somos",
	CONTACTO: "contacto",

	// Sub categories
	MANTENIMIENTOPREVENTIVO: `${constants.SERVICIOS}/mantenimiento-preventivo`,
	MANTENIMIENTOCORRECTIVO: `${constants.SERVICIOS}/mantenimiento-correctivo`,
	INSTALACIONAIREACONDICIONADO: `${constants.SERVICIOS}/instalacion-aire-acondicionado`,
	INSTALACIONLAMPARASSEGURIDAD: `${constants.SERVICIOS}/instalacion-lamparas-seguridad`,
	INSTALACIONCAMARASSEGURIDAD: `${constants.SERVICIOS}/instalacion-camaras-seguridad`,
	MANTENIMIENTOTABLEROSELECTRICO: `${constants.SERVICIOS}/mantenimiento-tableros-electricos`,
	INSTALACIONESMANTENIMIENTOCORTINAAIRE: `${constants.SERVICIOS}/instalaciones-mantenimiento-cortina-aire`
}


const LINKS = {
	"Inicio":PAGES.INICIO,
	"Nosotros":PAGES.NOSOTROS,
	"Contacto":PAGES.CONTACTO,
	"Hablamos":PAGES.CONTACTO,
	"Servicios":constants.SERVICIOS,
	"Mantenimiento Preventivo":PAGES.MANTENIMIENTOPREVENTIVO,
	"Mantenimiento Correctivo":PAGES.MANTENIMIENTOCORRECTIVO,
	"Instalación de Aire Acondicionado":PAGES.INSTALACIONAIREACONDICIONADO,
	"Instalación de Lámparas de Seguridad":PAGES.INSTALACIONLAMPARASSEGURIDAD,
	"Instalación de Cámaras de Seguridad":PAGES.INSTALACIONCAMARASSEGURIDAD,
	"Mantenimiento de Tableros Eléctricos":PAGES.MANTENIMIENTOTABLEROSELECTRICO,
	"Instalaciónes y Mantenimiento de Cortina de Aire":PAGES.INSTALACIONESMANTENIMIENTOCORTINAAIRE
}

export const SERVICES = {
	"Instalación de Aire Acondicionado":PAGES.INSTALACIONAIREACONDICIONADO,
	"Instalación de Cámaras de Seguridad":PAGES.INSTALACIONCAMARASSEGURIDAD,
	"Mantenimiento Correctivo":PAGES.MANTENIMIENTOCORRECTIVO,
	"Instalaciónes y Mantenimiento de Cortina de Aire":PAGES.INSTALACIONESMANTENIMIENTOCORTINAAIRE,
	"Instalación de Lámparas de Seguridad":PAGES.INSTALACIONLAMPARASSEGURIDAD,
	"Mantenimiento Preventivo":PAGES.MANTENIMIENTOPREVENTIVO,
	"Mantenimiento de Tableros Eléctricos":PAGES.MANTENIMIENTOTABLEROSELECTRICO,
}

export default LINKS;
